import { TTab } from '../../../utils';
import style from './Tab.module.scss';
import avatarIcon from "../../../assets/pictures/icons/avatar-icon.svg";
import sceneIcon from "../../../assets/pictures/icons/video-icon.svg";
import viewIcon from "../../../assets/pictures/icons/view-icon-grey.svg";
import { useMediaPreview } from '../../PreviewAvatarMedia/MediaPreviewProvider';

type Props = {
  name: TTab;
  active: boolean;
  setActiveTab: (tab: TTab) => void;
};

const tabsMap: Record<TTab, string> = {
  appearance: 'Аватар',
  scene: 'Сцена',
  preview: 'Предпросмотр',
};

const iconsMap: Record<TTab, JSX.Element> = {
  appearance: <img src={avatarIcon} alt="avatar icon" />,
  scene: <div className={style.icon}><img src={sceneIcon} alt="camera icon" /></div>,
  preview: <div className={style.icon}><img src={viewIcon} alt="eye icon" /></div>,
};

export const Tab = ({ name, active, setActiveTab }: Props) => {
  const { setCurrentTab } = useMediaPreview();

  const handleClick = () => {
    setActiveTab(name);
    setCurrentTab(name);
  };
  
  return (
      <div className={`${style.tabContainer} ${active && style.active}`} onClick={handleClick}>
        {iconsMap[name]}
        <span>{tabsMap[name]}</span>
      </div>
  );
};
